import React from "react";

import ButtonWithIcon from "@/components/ui/ButtonWithIcon";
import { DRIVE_CONSTANTS } from "@/constants/Drive.constant";
import { useDocumentManager } from "@/hooks/useDocumentManager";

interface SampleDirLoaderProps {
  variant?:
    | "outline"
    | "default"
    | "destructive"
    | "secondary"
    | "ghost"
    | "link";
  className?: string;
  type: string;
  id: string;
}

export const SampleDirLoader: React.FC<SampleDirLoaderProps> = ({
  variant = "outline",
  className,
  type,
  id,
}) => {
  const { handleLoadSample } = useDocumentManager({ type });

  return (
    <ButtonWithIcon
      onClick={() => handleLoadSample(id)}
      variant={variant}
      className={className}
      icon='folder'
    >
      {DRIVE_CONSTANTS.LABELS.LOAD_SAMPLE_TITLE}
    </ButtonWithIcon>
  );
};

export default SampleDirLoader;
